/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { motion, useMotionValue } from 'motion/react';
import { cn } from "@/utils/theme/cn";
export default function FadeInOnView(param) {
    let { className, children } = param;
    // hooks
    const value = useMotionValue(0);
    return /*#__PURE__*/ _jsx(motion.div, {
        style: {
            opacity: value
        },
        className: cn('duration-300 inline', className),
        onViewportEnter: ()=>setTimeout(()=>value.set(1), 1000),
        viewport: {
            once: true
        },
        children: children
    });
}
